import React, { useEffect, useState } from 'react';

const AnimatedCounter = (param) => {
  const [id, setId] = useState();
  const [duration, setDuration] = useState();
  const [delay, setDelay] = useState();

  useEffect(() => {
    const counter = document.querySelector(`[data-counter="${param.serial}"]`);
    setId(param.serial);
    setDuration(param.duration);
    setDelay(param.delay);

    setTimeout(() => {
      counter.classList.add('animate');
    }, 500);
  }, []);

  const css = `
    @property --num {
      syntax: '<integer>';
      initial-value: 0;
      inherits: false;
    }
    #counter-${id} {
      transition: --num ${duration}s ${delay}s;
      counter-reset: num var(--num);
    }
    counter::after {
      content: counter(num);
    }
    #counter-${id}.animate {
      --num: ${param.number};
    }
  `;

  return (
    <>
      <style>{css}</style>
      <counter id={`counter-${id}`} data-counter={param.serial}></counter>
    </>
  );
};

export default AnimatedCounter;
